import React, { useContext } from 'react';
import { Drawer, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { MenuContext } from '../../context/Menu';
import Logo from './Logo';
import Menu from './Menu';

const MenuContainer = styled('div')(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`);

const SidebarContainer = styled('div')(() => ({
  backgroundColor: 'var(--mui-palette-background-white)',
  height: '100vh',
  transition: 'width 0.2s ease-in',
}));

function Sidebar() {
  const { menuWidth } = useContext(MenuContext);
  return (
    <SidebarContainer style={{ width: `${menuWidth}px` }}>
      <MenuContainer>
        {/* <MenuCurveShapeContainer>
          <MenuCurveShapeBox />
        </MenuCurveShapeContainer> */}
        <div className="w-full">
          <Logo />
          <Menu />
        </div>
      </MenuContainer>
    </SidebarContainer>
  );
}

function ResponsiveSidebar() {
  const theme = useTheme();
  const renderMobileMenu = useMediaQuery(theme.breakpoints.down('md'));
  const { menuWidth, showMobileMenu, setShowMobileMenu } = useContext(MenuContext);
  const onClose = function () {
    setShowMobileMenu?.(false);
  };
  return (
    <>
      {renderMobileMenu && (
        <Drawer anchor={'left'} open={showMobileMenu} onClose={onClose}>
          <div style={{ width: `${menuWidth}px`, height: '100%' }}>
            <Sidebar />
          </div>
        </Drawer>
      )}
      {!renderMobileMenu && <Sidebar />}
    </>
  );
}

export default ResponsiveSidebar;
